<template>
  <google-map-loader :mapConfig="mapConfig">
    <template slot-scope="{ google, map }">
      <google-map-marker
        :marker="floatMarker"
        :google="google"
        :map="map"
        ref="floatMarker"
        :floating="true"
        :nearestLocation="nearestLocation"
      />
      <google-map-line :path="line" :google="google" :map="map" />
      <google-map-bounds :path="line" :google="google" :map="map" />
    </template>
  </google-map-loader>
</template>

<script>
import GoogleMapLoader from "./GoogleMapLoader";
import GoogleMapMarker from "./GoogleMapMarker.vue";
import GoogleMapLine from "./GoogleMapLine.vue";
import GoogleMapBounds from "./GoogleMapBounds.vue";
import { mapSettings } from "../../utils/mapSettings";

export default {
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
    GoogleMapLine,
    GoogleMapBounds,
  },

  props: ["location", "setHoveredData"],

  data() {
    return {
      markers: [],
      loading: true,
      overlay: false,
      bounds: {},
      floatMarker: {
        id: "float",
        position: null,
        time: null,
      },
    };
  },

  created() {},

  computed: {
    line() {
      return this.location.map((item) => item.position);
    },
    firstPosition() {
      if (typeof this.location.position !== "undefined") {
        return this.location[0].position;
      } else {
        return { lat: 0, lng: 0 };
      }
    },
    mapConfig() {
      return {
        ...mapSettings,
        center: this.firstPosition,
      };
    },
    nearestLocation() {
      if (!this.setHoveredData || !this.location || this.location.length === 0) {
        return null;
      }

      // Find the location point closest to the hovered timestamp
      return this.location.reduce((nearest, current) => {
        const currentDiff = Math.abs(current.created - this.setHoveredData);
        const nearestDiff = nearest ? Math.abs(nearest.created - this.setHoveredData) : Infinity;
        return currentDiff < nearestDiff ? current : nearest;
      }, null);
    },
  },

  methods: {},
};
</script>
